import { Result, Row, Col, Card, Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { TradesContext } from '../../contexts/tradeProcessContext';
import { useState } from 'react';
import { formatLabel } from '../../util/Common';

const SuccessfulResponse = () => {
  const { tradeResponse } = useContext(TradesContext);

  const [copiedKey, setCopiedKey] = useState(null);

  const handleCopy = (key, value) => {
    navigator.clipboard.writeText(value);

    setCopiedKey(key);

    // reset state after 1s
    setTimeout(() => setCopiedKey(null), 1000);
  };

  const ResponseCard = ({ title, value }) => (
    <Card
      style={{
        width: '100%',
        height: '100%',
        textAlign: 'start',
        position: 'relative',
      }}
    >
      {
        title.toLowerCase().includes('id') && (
          <Button
            style={{ position: 'absolute', top: '10px', right: '10px' }}
            onClick={() => handleCopy(title, value)}
            // size="small"
          >
            <CopyOutlined />
            {copiedKey === title ? 'Copied!' : 'Copy'}
          </Button>
        )
      }
      <p
        style={{
          fontSize: '1rem',
          color: '#555',
          textTransform: 'capitalize',
        }}
      >
        {formatLabel(title)}
      </p>
      <p
        style={{
          fontSize: '2rem',
          fontWeight: 'bold',
        }}
      >
        {value}
      </p>
    </Card>
  );

  return (
    <Result
      status={tradeResponse !== null ? 'success' : 'error'}
      title={tradeResponse !== null ? 'Trade Process Successful' : 'Trade Process Failed'}
      // subTitle={`Matching ID: ${tradeResponse.matchingProcessId}, Settlement ID: ${tradeResponse.tradeProcessId}, Settlement Window: ${tradeResponse.tradeWindow},`}
      subTitle={
        tradeResponse && <Row
          gutter={[16, 16]}
          style={{
            marginTop: '2rem',
          }}
        >
          {Object.entries(tradeResponse).map(([key, value]) => (
            <Col
              key={key}
              xs={{
                span: 24,
              }}
              md={{
                span: 12,
              }}
            >
              <ResponseCard title={key} value={value} />
            </Col>
          ))}
        </Row>
      }
      style={{
        padding: 0,
      }}
    />
  );
};

export default SuccessfulResponse;
